const postBookingUtils = require('../utils/post_booking.utils');
const trackingUtils = require('../utils/tracking.utils');
const aircraftmapFactory = require('components/bags_and_seats/aircraftmap/js/main');
const aircraftmapManagerFactory = require('components/bags_and_seats/aircraftmap_manager/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const pbAncillariesCollection = require('od-modules/collections/pb_ancillaries_collection/collection');
const seatMapId = Odigeo.SessionScope.flow === 'desktop' ? 'seatmap-desktop' : 'post-booking-seatmap';
const seatMapName = Odigeo.SessionScope.flow === 'desktop' ? 'seatmap_desktop' : 'seatmap';
const widgets = Odigeo.autoloadWidgetsAsync({
    getBags: ['post-booking-bags', 'post_booking_bags'],
    getSeats: ['post-booking-seats', 'post_booking_seats'],
    getBinDetectionSeats: ['post-booking-bin-detection-seats', 'post_booking_bin_detection'],
    getBinDetectionBags: ['post-booking-bin-detection-bags', 'post_booking_bin_detection'],
    getPaymentSeats: ['post-booking-payment-seats', 'payment'],
    getPaymentBags: ['post-booking-payment-bags', 'payment'],
    getSeatMap: [seatMapId, seatMapName],
    getUsersManager: ['users-manager', 'usersmanager'],
});
const widgetLoader = createWidgetLoader({
    aircraftMapDesktop: ['aircraft-desktop', aircraftmapManagerFactory],
    aircraftMap: ['post-booking-aircraftmap', aircraftmapFactory],
    aircraftMapCheckIn: ['aircraftmap-checkin', aircraftmapManagerFactory],
    aircraftMapCheckInMobile: ['aircraftmap-checkin-mobile', aircraftmapFactory],
});

class CallOnce {
    constructor(handler = () => {}) {
        this.executed = false;
        this.handler = handler;
    }

    executeOnce() {
        return this.executed ? false : this.execute();
    }

    execute() {
        this.executed = true;
        this.handler();
    }
}

const trackNoBaggage = new CallOnce(() => trackingUtils.trackEventWithCategory(
    'my_area_trips_details',
    'baggage_offline_no-available',
    'baggage_offline_no-available_appearances'));

const trackNoSeats = new CallOnce(() => trackingUtils.trackEventWithCategory(
    'my_area_trips_details',
    'seats_offline_no-available',
    'seats_offline_no-available_appearances'));

const onOpenAddBagsFailure = () => {
    trackNoBaggage.executeOnce();
    widgets.getBags().execute('showFailure');
};

const onOpenAddSeatsFailure = () => {
    trackNoSeats.executeOnce();
    widgets.getSeats().execute('showFailure');
};

module.exports = {
    viewEvents: {
        'aircraftmap:closeAircraftMap': 'onCloseAircraftMap',
        'aircraftmap:closeAircraftMapCheckIn': 'closeAircraftMapCheckIn',
        'aircraftmap:trackCloseAircraftMap': 'trackCloseAircraftMap',
        'aircraftmap:moveToOtherSection': 'onMoveToOtherSection',
        'aircraftmap:hideErrors': 'onSeatmapHideErrors',
        'aircraftmap:showErrors': 'onSeatmapShowErrors',
        'aircraftmap_manager:updateSeatSelectionFees': 'onUpdateSeatSelectionFees',
        'aircraftmap_manager:tapNavigateButton': 'onTapAircraftMapNavigateButton',
        'aircraftmap_manager:closeAircraftMap': 'onCloseAircraftMapDesktop',
        'aircraftmap_manager:trackCloseAircraftMap': 'trackCloseAircraftMapDesktop',
        'seatmap-desktop:openAircraftMap': 'onOpenAircraftMapDesktop',
        'seatmap-desktop:checkPassengerCollectionPopulated': 'onCheckPassengerCollectionPopulated',
        'seatmap-desktop:moveToShoppingPhase': 'onMoveToShoppingPhaseSeatMap',
        'seatmap-checkin:openAircraftMap': 'onOpenAircraftMapCheckIn',
        'seatmap-checkin:initSeatMapCheckinScroll': 'onInitSeatMapCheckinScroll',
        'seatmap-checkin:checkPassengerCollectionPopulatedCheckIn': 'onCheckPassengerCollectionPopulatedCheckIn',
        'seatmap-checkin:moveToShoppingPhase': 'onMoveToShoppingPhaseSeatMapCheckIn',
        'seatmap-checkin-mobile:openAircraftMap': 'onOpenAircraftMapCheckIn',
        'my-trips:openAddBags': 'onOpenAddBags',
        'my-trips:openAddSeats': 'onOpenAddSeats',
        'post-booking-bags:closeAddBags': 'onCloseAddBags',
        'post-booking-bags:noBagsAvailable': 'onOpenAddBagsFailure',
        'post-booking-bags:purchaseOk': 'onPurchaseOk',
        'post-booking-bags:purchasePaymentError': 'onPurchasePaymentError',
        'post-booking-bags:purchaseError': 'onPurchaseError',
        'post-booking-seats:closeAddSeats': 'onCloseAddSeats',
        'post-booking-seats:closeAircraftMap': 'onCloseAircraftMapDesktop',
        'post-booking-seats:trackCloseAircraftMap': 'trackCloseAircraftMapDesktop',
        'post-booking-seats:noSeatsAvailable': 'onOpenAddSeatsFailure',
        'post-booking-seats:purchaseOk': 'onPurchaseOk',
        'post-booking-seats:purchasePaymentError': 'onPurchasePaymentError',
        'post-booking-seats:purchaseError': 'onPurchaseError',
        'post-booking-bin-detection-seats:creditCardTypeCodeChanged': 'onCreditCardTypeCodeChanged',
        'post-booking-bin-detection-bags:creditCardTypeCodeChanged': 'onCreditCardTypeCodeChanged',
        'post-booking-payment-seats:cardDataChanged': 'onCardDataChanged',
        'post-booking-payment-bags:cardDataChanged': 'onCardDataChanged',
        'one-click-checkout-post-booking-bags-bin-detection:creditCardTypeCodeChanged': 'onCreditCardTypeCodeChangedOneClickCheckoutBags',
        'one-click-checkout-post-booking-bags-payment-form:cardDataChanged': 'onCardDataChangedOneClickCheckoutBags',
        'one-click-checkout-post-booking-bags:onCheckoutConfirm': 'onCheckoutConfirmPostBookingBags',
        'one-click-checkout-post-booking-bags:onCheckoutPaymentRetry': 'onCheckoutPaymentRetryPostBookingBags',
        'one-click-checkout-post-booking-bags:onCheckoutInteractionNeeded': 'onCheckoutInteractionNeededBags',
        'one-click-checkout-post-booking-bags:close': 'onCloseAddBags',
        'one-click-checkout-post-booking-bags:retryPayment': 'onRetryPaymentBags',
        'one-click-checkout-post-booking-bags:genericError': 'onGenericErrorBags',
        'one-click-checkout-post-booking-seats-bin-detection:creditCardTypeCodeChanged': 'onCreditCardTypeCodeChangedOneClickCheckoutSeats',
        'one-click-checkout-post-booking-seats-payment-form:cardDataChanged': 'onCardDataChangedOneClickCheckoutSeats',
        'one-click-checkout-post-booking-seats:onCheckoutConfirm': 'onCheckoutConfirmPostBookingSeats',
        'one-click-checkout-post-booking-seats:onCheckoutPaymentRetry': 'onCheckoutPaymentRetryPostBookingSeats',
        'one-click-checkout-post-booking-seats:onCheckoutInteractionNeeded': 'onCheckoutInteractionNeededSeats',
        'one-click-checkout-post-booking-seats:close': 'onCloseAddSeats',
        'one-click-checkout-post-booking-seats:retryPayment': 'onRetryPaymentSeats',
        'one-click-checkout-post-booking-seats:genericError': 'onGenericErrorSeats',
        'post-booking-seatmap:openAircraftMap': 'onOpenAircraftMap',
        'trip-details:openAddBags': 'onOpenAddBags',
        'trip-details:openAddSeats': 'onOpenAddSeats',
    },

    eventHandlers: {
        onCheckoutConfirmPostBookingBags() {
            widgets.getBags().execute('onCheckoutConfirm');
        },
        onCheckoutPaymentRetryPostBookingBags() {
            widgets.getBags().execute('onCheckoutPaymentRetry');
        },
        onCheckoutInteractionNeededBags() {
            widgets.getBags().execute('onCheckoutInteractionNeeded');
        },
        onCheckoutConfirmPostBookingSeats() {
            widgets.getSeats().execute('onCheckoutConfirm');
        },
        onCheckoutPaymentRetryPostBookingSeats() {
            widgets.getSeats().execute('onCheckoutPaymentRetry');
        },
        onCheckoutInteractionNeededSeats() {
            widgets.getSeats().execute('onCheckoutInteractionNeeded');
        },
        onOpenAircraftMapCheckIn: function(seatMap, aircraftOptions) {
            const widgetId = Odigeo.SessionScope.flow === 'desktop' ? 'aircraftMapCheckIn' : 'aircraftMapCheckInMobile';
            widgetLoader.get(widgetId).execute('onOpenAircraftMap', seatMap, aircraftOptions);
        },
        onInitSeatMapCheckinScroll: function() {
            widgetLoader.get('aircraftMapCheckIn').execute('initSeatMapCheckinScroll');
        },
        onMoveToShoppingPhaseSeatMapCheckIn: function() {
            widgetLoader.get('aircraftMapCheckIn').execute('onCloseAircraftMap');
        },
        onOpenAddBags: function(bookingInfo, ancillaryInfo, showFlightInfo) {
            var bookingId = bookingInfo.bookingBasicInfo.id;
            var collectionMethods = postBookingUtils.getCollectionMethods(ancillaryInfo);
            var acceptedCreditCardTypeCodes = postBookingUtils.getCreditCardTypeCodes(collectionMethods);

            if (!Odigeo.AB.isOneClickCheckout) {
                widgets.getPaymentBags().execute('setPaymentOptions', bookingId, collectionMethods, acceptedCreditCardTypeCodes);
            }

            widgets.getBags().execute('showAddBags', bookingInfo, ancillaryInfo, showFlightInfo);
        },
        onOpenAddBagsFailure() {
            onOpenAddBagsFailure();
        },
        onOpenAddSeats: function(bookingInfo, ancillaryInfo, showFlightInfo) {
            var bookingId = bookingInfo.bookingBasicInfo.id;
            var collectionMethods = postBookingUtils.getCollectionMethods(ancillaryInfo);
            var acceptedCreditCardTypeCodes = postBookingUtils.getCreditCardTypeCodes(collectionMethods);

            if (!Odigeo.AB.isOneClickCheckout) {
                widgets.getPaymentSeats().execute('setPaymentOptions', bookingId, collectionMethods, acceptedCreditCardTypeCodes);
            }

            widgets.getSeats().execute('showAddSeats', bookingInfo, ancillaryInfo, showFlightInfo);
            widgets.getSeatMap().execute('loadFromParameters', bookingInfo, ancillaryInfo, 'postBooking');
        },
        onMoveToShoppingPhaseSeatMap: function() {
            widgets.getSeats().execute('changePhase', 'SHOPPING');
            widgetLoader.get('aircraftMap').execute('onCloseAircraftMap');
        },
        onOpenAddSeatsFailure() {
            onOpenAddSeatsFailure();
        },
        onCardDataChanged: function(isValid, paymentDetails) {
            widgets.getBags().execute('setCardData', isValid, paymentDetails);
            widgets.getSeats().execute('setCardData', isValid, paymentDetails);
        },
        onCardDataChangedOneClickCheckoutSeats(isValid, paymentDetails) {
            widgets.getSeats().execute('setCardData', isValid, paymentDetails);
        },
        onCardDataChangedOneClickCheckoutBags(isValid, paymentDetails) {
            widgets.getBags().execute('setCardData', isValid, paymentDetails);
        },
        onCreditCardTypeCodeChangedOneClickCheckoutSeats(creditCardTypeCode, creditCardTypeName) {
            widgets.getSeats().execute('setCreditCardTypeCode', creditCardTypeCode, creditCardTypeName);
        },
        onCreditCardTypeCodeChangedOneClickCheckoutBags(creditCardTypeCode, creditCardTypeName) {
            widgets.getBags().execute('setCreditCardTypeCode', creditCardTypeCode, creditCardTypeName);
        },
        onCreditCardTypeCodeChanged: function(creditCardTypeCode, creditCardTypeName) {
            widgets.getPaymentSeats().execute('setCreditCardTypeCode', creditCardTypeCode);
            widgets.getPaymentBags().execute('setCreditCardTypeCode', creditCardTypeCode);
            widgets.getBags().execute('setCreditCardTypeCode', creditCardTypeCode, creditCardTypeName);
            widgets.getSeats().execute('setCreditCardTypeCode', creditCardTypeCode, creditCardTypeName);
        },
        onPurchaseOk: function(type) {
            if (type === 'bags') {
                widgets.getBags().execute('showSuccess');
            } else if (type === 'seats') {
                widgets.getSeats().execute('showSuccess');
            }
        },
        onPurchasePaymentError: function(type) {
            if (type === 'bags') {
                widgets.getBags().execute('showPaymentFailure');
            } else if (type === 'seats') {
                widgets.getSeats().execute('showPaymentFailure');
            }
        },
        onPurchaseError: function(type) {
            if (type === 'bags') {
                widgets.getBags().execute('showFailure');
            } else if (type === 'seats') {
                widgets.getSeats().execute('showFailure');
            }
        },
        onCloseAddBags: function() {
            widgets.getBags().execute('close');
        },
        onRetryPaymentBags: function() {
            widgets.getBags().execute('moveToPayment');
        },
        onGenericErrorBags() {
            widgets.getBags().execute('showFailure');
        },
        onCloseAddSeats: function() {
            widgets.getSeats().execute('close');
        },
        onRetryPaymentSeats: function() {
            widgets.getSeats().execute('moveToPayment');
        },
        onGenericErrorSeats() {
            widgets.getSeats().execute('showFailure');
        },
        onOpenAircraftMap: function(seatMap, aircraftOptions) {
            widgetLoader.get('aircraftMap').execute('onOpenAircraftMap', seatMap, aircraftOptions);
        },
        onOpenAircraftMapDesktop: function(seatMap, aircraftOptions) {
            widgetLoader.get('aircraftMapDesktop').execute('onOpenAircraftMap', seatMap, aircraftOptions);
        },
        onCheckPassengerCollectionPopulated: function() {
            widgetLoader.get('aircraftMapDesktop').execute('checkPassengerCollectionPopulated');
        },
        onCheckPassengerCollectionPopulatedCheckIn: function() {
            widgetLoader.get('aircraftMapCheckIn').execute('checkPassengerCollectionPopulated');
        },
        onCloseAircraftMap: function() {
            widgets.getSeatMap().execute('onHideErrors');
            widgetLoader.get('aircraftMap').execute('onCloseAircraftMap');
        },
        closeAircraftMapCheckIn: function(source) {
            const isDesktop = Odigeo.SessionScope.flow === 'desktop';
            const aircraftComponent = isDesktop ? 'aircraftMapCheckIn' : 'aircraftMapCheckInMobile';
            widgetLoader.get(aircraftComponent).execute('onCloseAircraftMap', source);
        },
        trackCloseAircraftMap: function() {
            widgets.getSeats().execute('onCloseAircraftMapTracking');
        },
        closeAircraft: function() {
            widgetLoader.get('aircraftMap').execute('onCloseAircraftMap');
        },
        onMoveToOtherSection: function(aircraftOptions, seatSelectionType) {
            widgets.getSeatMap().execute('onMoveThroughOpenAircraftMap', aircraftOptions, seatSelectionType);
        },
        onSeatmapShowErrors: function() {
            widgets.getSeatMap().execute('onShowErrors');
        },
        onUpdateSeatSelectionFees: function() {
            widgets.getSeatMap().execute('updateSeatSelectionFees');
        },
        onTapAircraftMapNavigateButton: function(flightDetails, step, aircraftOptions) {
            widgets.getSeatMap().execute('onTapNavigateButton', flightDetails, step, aircraftOptions);
        },
        onCloseAircraftMapDesktop: function() {
            widgets.getSeatMap().execute('onCloseAircraftMap');
            widgets.getSeats().execute('scrollTop');
        },
        trackCloseAircraftMapDesktop: function() {
            widgets.getSeats().execute('onCloseAircraftMapTracking');
        },
        onSeatmapHideErrors: function() {
            widgets.getSeatMap().execute('onHideErrors');
        },
    },

    init: function() {
        widgets.getBinDetectionSeats();
        widgets.getBinDetectionBags();
        widgetLoader.get('aircraftMapDesktop');

        pbAncillariesCollection.onTripBagsLoaded({
            success: (data) => widgets.getBags().execute('checkAvailableBags', data),
            failure: onOpenAddBagsFailure,
        });

        pbAncillariesCollection.onTripSeatsLoaded({
            success: (data) => widgets.getSeats().execute('checkAvailableSeats', data),
            failure: onOpenAddSeatsFailure,
        });
    },
};
